import { render, staticRenderFns } from "./HeaderTop.vue?vue&type=template&id=044c12fa&scoped=true"
import script from "./HeaderTop.vue?vue&type=script&lang=js"
export * from "./HeaderTop.vue?vue&type=script&lang=js"
import style0 from "./HeaderTop.vue?vue&type=style&index=0&id=044c12fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c12fa",
  null
  
)

export default component.exports